// extracted by mini-css-extract-plugin
export var container = "_c8-0";
export var popoverContent = "_c8-1";
export var tosLink = "_c8-2";